<template>
    <section v-if="localizedPages.length || specialities.length" class="slice job-page__tags">
        <ShapeContent class="job-page__tags__shape" />
        <div class="slice-content relative">
            <div class="job-page__tags__wrapper">
                <div v-if="localizedPages.length">
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <h3 v-html="t('landing.acquisition.related.searches.localized.title', [jobLabel])" />
                    <ul>
                        <li v-for="({url, label}, i) in localizedPages" :key="i">
                            <NuxtLink v-if="url" :to="$withLocalePrefix(url)" external>
                                <VJoyTag link variant="inactive">
                                    {{ t('landing.acquisition.related.searches.localized.label', [jobLabel, label]) }}
                                </VJoyTag>
                            </NuxtLink>
                        </li>
                    </ul>
                </div>
                <div v-if="specialities.length">
                    <h3>{{ t('landing.acquisition.related.searches.speciality.title') }}</h3>
                    <ul>
                        <li v-for="({url, label}, i) in specialities" :key="i">
                            <NuxtLink v-if="url" :to="$withLocalePrefix(url)" external>
                                <VJoyTag link variant="inactive">{{ label }}</VJoyTag>
                            </NuxtLink>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {inject} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyTag} from '@maltjoy/core-vue';
    import ShapeContent from '~/components/shape/ShapeContent.vue';
    import {JOB_PAGE} from '~/keys';

    const {landingPage} = inject(JOB_PAGE) || {};

    const {t} = useTranslation();

    const {textualContent} = landingPage || {};
    const jobLabel = textualContent?.thisPage.jobLabel;
    const localizedPages = textualContent?.localitySeoPages || [];
    const specialities = textualContent?.specialitySeoPages || [];
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .job-page__tags {
        position: relative;
        max-width: 100%;

        .slice-content {
            @include mq.screen_sm(min) {
                margin-bottom: 50px;
            }
            @include mq.screen_lg(min) {
                margin-bottom: 100px;
                height: 36vw;
                max-height: 612px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        &__shape {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%, -4%);
            width: auto;
            height: 145%;
            @include mq.screen_md(min) {
                transform: translate(-50%, -2%);
            }
            @include mq.screen_lg(min) {
                height: auto;
                width: 100vw;
                max-width: 1700px;
            }
        }
        &__wrapper {
            position: relative;
            text-align: left;
            margin: 0 auto;

            > div {
                margin-bottom: var(--joy-core-spacing-9);
            }
            @include mq.screen_md(min) {
                display: flex;
                gap: var(--joy-core-spacing-12);
                padding: 0 var(--joy-core-spacing-12);
                > div {
                    margin-bottom: 0;
                    flex: 1;
                }
            }
            @include mq.screen_lg(min) {
            }
            h3 {
                font-family: var(--joy-font-family-title);
                margin-bottom: var(--joy-core-spacing-5);
                font-size: var(--joy-font-size-primary-600);
                color: var(--joy-color-text-title);

                @include mq.screen_md(min) {
                    font-size: var(--joy-font-size-secondary-200);
                }
            }
            ul {
                list-style-type: none;
                margin: 0;
                display: flex;
                flex-wrap: wrap;
                column-gap: var(--joy-core-spacing-4);
                row-gap: 0;
            }
            li {
                display: flex;
                align-items: center;
                gap: var(--joy-core-spacing-1);
                margin-bottom: var(--joy-core-spacing-2);
            }

            .joy-link {
                font-weight: var(--joy-font-weight-normal);
            }
        }
        .joy-tag {
            border: 1px solid transparent;
            color: var(--joy-color-text-title);
            &:hover {
                border-color: var(--joy-color-neutral-70);
                color: var(--joy-color-neutral-70);
            }
        }
    }
</style>
